import React from 'react';
import { DivScrollBody } from './styles';

export function Termo() {

	return (
		<DivScrollBody style={{ overflowX: 'auto', fontSize: '14px', height: '500px' }}>
			<h6 style={{ paddingTop: '1pt', textIndent: '0pt', textAlign: 'center' }}>
				POLÍTICA DE CONTESTAÇÃO (“CHARGEBACK”) E CANCELAMENTO LUCREE
			</h6>
			<p style={{ paddingBottom: '40px', textAlign: 'center' }}>23.0112</p>

			<h7>
				<b>1. APROVAÇÃO DA TRANSAÇÃO</b>
			</h7>
			{/* Tópico 1 */}
			<p style={{ textAlign: 'justify' }}>
				<b>1.1 </b>
				A aprovação de uma transação pela LUCREE, mediante código de autorização, não atesta que esta seja livre de irregularidades, as quais poderão ser apuradas, resultando, ou não, em CHARGEBACK. Ainda assim, a transação poderá ser objeto de requisição de cancelamento pelo ESTABELECIMENTO, hipótese na qual o valor líquido não será creditado ao ESTABELECIMENTO ou, caso já tenha sido, deverá ser restituído à LUCREE.
			</p>

			<h7>
				<b>2. CHARGEBACK</b>
			</h7>

			{/* Tópico 2 */}
			<p style={{ textAlign: 'justify' }}>
				<b>2.1 </b>
				CHARGEBACK significa a devolução de uma transação após “Processo de Contestação de Transação” promovido pelo PORTADOR DO CARTÃO ou pelo emissor do cartão, de acordo com as regras e prazos definidos pelas BANDEIRAS. Pode acontecer quando o titular do cartão entra em contato com a operadora alegando não ter recebido o produto/serviço ou quando não reconhece determinado lançamento em sua fatura, além de outras hipóteses.
			</p>
			<p style={{ textAlign: 'justify' }}>
				<b>2.2 </b>
				No caso de Processo de Contestação de Transação, a LUCREE solicitará ao ESTABELECIMENTO a comprovação da transação, observando-se as seguintes regras e condições:
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				I. Sempre que solicitado pela LUCREE, o ESTABELECIMENTO deverá enviar o comprovante de venda assinado pelo portador do cartão e todos os outros documentos hábeis a certificar a efetivação da venda e da entrega do produto e/ou prestação do serviço, no prazo de 7 (sete) dias a contar do recebimento da solicitação através da Central de Contestações da LUCREE. Para cumprimento do que aqui se dispõe, o ESTABELECIMENTO deverá manter arquivados, pelo prazo de 18 meses, os comprovantes originais das transações e suas respectivas cópias (visando preservar a integridade das informações), além de todo e qualquer documento que possa atestar a regularidade da transação;
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				II. No caso de venda fora do estabelecimento, o ESTABELECIMENTO deverá comprovar a participação do PORTADOR DO CARTÃO na especificação do produto (trocas de mensagens, chat, alterações de produtos e afins);
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				III. No caso de venda fora do estabelecimento, o ESTABELECIMENTO deverá comprovar a entrega do produto através do AR (Aviso de Recebimento) assinado pelo portador do cartão. Caso a entrega tenha sido feita por transportadora, também será necessário apresentar o comprovante de recebimento do produto;
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				IV. O ESTABELECIMENTO deverá enviar a documentação completa solicitada pela LUCREE para análise e possível desbloqueio do pagamento contestado. Caso o ESTABELECIMENTO não envie todos os documentos no prazo solicitado, o valor da transação não será liquidado ao ESTABELECIMENTO;
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				VI. Nos casos de duplicidade de pagamento, o ESTABELECIMENTO deverá enviar o comprovante de venda assinado pelo PORTADOR DO CARTÃO e todos os outros documentos hábeis a comprovar a efetivação da venda e da entrega do produto e/ou prestação do serviço no prazo de 7 (sete) dias, a contar do recebimento da solicitação, através da Central de Contestações da LUCREE;
			</p>

			{/* Tópico 3 */}
			<p style={{ textAlign: 'justify' }}>
				<b>2.3 </b>
				A critério da LUCREE e das entidades responsáveis pela análise do Processo de Contestação (EMISSORES, BANDEIRAS e ADQUIRENTES), podem ser considerados como válidos para comprovar a transação, no mínimo, os seguintes dados ou documentos:
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				I. Carta explicativa sobre o ocorrido com a transação contestada;
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				II. Código de rastreamento e aviso de recebimento (A.R.) assinado relativos ao produto entregue;
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				III. COMPROVANTES DE VENDAS;
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				IV. Nota Fiscal contendo todos os produtos/serviços adquiridos/consumidos pelo PORTADOR DO CARTÃO;
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				V. Imagem da oferta que confirme que o produto foi entregue conforme anunciado;
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				VI. Documento com foto do PORTADOR DO CARTÃO. Caso o consumidor não seja o PORTADOR DO CARTÃO, o ESTABELECIMENTO precisará comprovar o vínculo entre PORTADOR DO CARTÃO e consumidor;
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				VII. Contrato de prestação de serviço assinado;
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				VIII. Documento Único de Transferência (“DUT”) e o documento com foto do PORTADOR DO CARTÃO, em caso de venda de veículo.
			</p>

			{/* Tópico 4 */}
			<p style={{ textAlign: 'justify' }}>
				<b>2.4 </b>
				As entidades responsáveis pela análise do Processo de Contestação (EMISSORES, BANDEIRAS e ADQUIRENTES) poderão levar em conta alguns critérios para qualificação do Processo de Contestação como procedente (quando procedente, o Processo de Contestação resulta em CHARGEBACK). A lista a seguir, de forma exemplificativa, reúne alguns critérios que poderão ser utilizados na análise (EMISSORES, BANDEIRAS e ADQUIRENTES poderão, cada qual, levar em conta quaisquer outros critérios que entendam aplicáveis):
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				I. Total de CHARGEBACKs historicamente sofridos pelo ESTABELECIMENTO;
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				II. Recorrência de CHARGEBACKs durante o período de 3 (três) meses;
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				III. Falta de envio dos documentos previstos no item 2.3, acima;
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				IV. Falta de envio do COMPROVANTE DE VENDAS assinado pelo PORTADOR DO CARTÃO e outros documentos hábeis a comprovar a efetivação da venda e da entrega do produto e/ou prestação do serviço no prazo de 7 (sete) dias, a contar do recebimento de solicitação, através da Central de Contestações da LUCREE;
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				V. Envio de AR (Aviso de Recebimento) sem assinatura do recebedor ou código de rastreamento inválido (Correios ou transportadoras);
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				VI. Envio de código de rastreamento cujo status (nos Correios ou Transportadora) não demonstre que o produto foi entregue com sucesso ao destinatário (devolvido ao remetente, extraviado, entre outros);
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				VII. Envio de código de rastreamento por meio do qual não seja possível localizar, na data da análise da contestação, a entrega do produto nos sites de logística (Correios ou Transportadoras);
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				VIII. Entrega de produto realizada em mãos sem recibo assinado e sem cópia de documento (RG e/ou CNH) que contenha assinatura idêntica à do recibo;
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				IX. Não promoção do cancelamento, pelo ESTABELECIMENTO e por solicitação da LUCREE, de um pagamento já aprovado e que posteriormente foram identificadas irregularidades;
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				X. Nos casos de duplicidade de pagamento, se não for enviada comprovação válida de entrega dos produtos.
			</p>

			{/* Tópico 5 */}
			<p style={{ textAlign: 'justify' }}>
				<b>2.5 </b>
				Caso haja contestação de transação por questões relacionados a prazos de entrega, condições do produto entregue e/ou dos serviços prestados pelo ESTABELECIMENTO, não serão aceitas justificativas encaminhadas pelo ESTABELECIMENTO quando:
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				I. Em casos de vendas ocorridas fora do estabelecimento comercial, o cancelamento da entrega do produto ou da prestação de serviços ocorrer sem prévio aviso e/ou sem informação da nova data a ser realizada;
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				II. Em casos de vendas ocorridas fora do estabelecimento comercial, o PORTADOR DO CARTÃO comprovar que efetuou a solicitação do cancelamento da compra no prazo de até 7 (sete) dias contados da data da compra ou do ato de recebimento do produto ou serviço, como garante o art. 49 do Código de Defesa do Consumidor, e o ESTABELECIMENTO não tiver cancelado a transação;
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				III. O ESTABELECIMENTO entregar produto com vício de qualidade que o torne impróprio ou inadequado ao consumo ou uso a que se destina;
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				IV. Em casos de vendas ocorridas fora do estabelecimento comercial, o PORTADOR DO CARTÃO comprovar através de código de rastreamento, ou outros, que devolveu o produto ao ESTABELECIMENTO;
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				V. O PORTADOR DO CARTÃO comprovar que tentou solucionar o problema com o ESTABELECIMENTO, mas que não obteve resposta;
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				VI. Em casos de vendas ocorridas fora do estabelecimento comercial, o ESTABELECIMENTO recusar injustificadamente o recebimento do produto devolvido pelo PORTADOR DO CARTÃO;
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				VII. O ESTABELECIMENTO não divulgar apropriadamente possíveis atrasos na entrega do produto e/ou na prestação dos serviços;
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				VIII. O ESTABELECIMENTO comercializar produtos/serviços diferentes da categoria informada em sua conta LUCREE;
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				IX. O ESTABELECIMENTO realizar o envio do produto ou executar o serviço somente em data igual ou posterior à data da contestação da compra.
			</p>


			<h7>
				<b>3. CANCELAMENTO</b>
			</h7>

			<p style={{ textAlign: 'justify' }}>
				<b>3.1 </b>
				Adicionalmente ao CHARGEBACK referido na Cláusula anterior, o ESTABELECIMENTO poderá não ter creditado o valor de uma ou mais transações em virtude de cancelamento.
			</p>

			<p style={{ textAlign: 'justify' }}>
				<b>3.2 </b>
				O cancelamento da transação poderá ser requerido pelo próprio ESTABELECIMENTO, hipótese na qual, após recebida a solicitação, a LUCREE promoverá o cancelamento e devolução do valor bruto da transação ao emissor em até 10 (dez) dias úteis.
			</p>

			<p style={{ textAlign: 'justify' }}>
				<b>3.2.1 </b>
				O ESTABELECIMENTO deverá observar os seguintes prazos e procedimentos para requisição de cancelamento:
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				a) Para solicitar cancelamento na própria máquina, a requisição deverá ser feita no equipamento no exato dia em que foi promovida a transação;
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				b) Se a solicitação de cancelamento não for promovida no mesmo dia, deverá ser feita no Portal LUCREE ou Central de Disputas, em até 10 (dez) dias úteis contados da venda tanto para a modalidade débito quanto para a modalidade crédito.
			</p>

			<p style={{ textAlign: 'justify' }}>
				<b>3.2.2 </b>
				Se o ESTABELECIMENTO não observar os prazos e condições dispostos na cláusula 3.2.1 acima, o cancelamento não será mais permitido, restando ao ESTABELECIMENTO buscar a resolução junto ao PORTADOR DO CARTÃO, não subsistindo qualquer responsabilidade da LUCREE nesse sentido.
			</p>


			<h7>
				<b>4. CHARGEBACK OU CANCELAMENTO APÓS LIQUIDAÇÃO</b>
			</h7>

			<p style={{ textAlign: 'justify' }}>
				<b>4.1 </b>
				Caso o CHARGEBACK ou a solicitação de cancelamento tenham sido promovidos depois da LUCREE ter liquidado o valor junto ao ESTABELECIMENTO, este fica obrigado a restituir a LUCREE dos valores devolvidos ao Emissor. A restituição será feita mediante compensação com os recebíveis do ESTABELECIMENTO. O montante bruto da venda será descontado dos recebíveis do ESTABELECIMENTO. Se não houver recebíveis ou se os mesmos se mostrarem insuficientes, fica a LUCREE autorizada a cobrar os valores por outros meios admitidos pela legislação, inclusive, mas não se limitando, a débito no domicílio bancário do ESTABELECIMENTO ou boleto bancário. Se a cobrança não se mostrar frutífera, ou seja, se houver dívida do ESTABELECIMENTO com a LUCREE nos termos desta cláusula, a LUCREE poderá, a seu exclusivo critério, requerer a inclusão de restrição em nome do ESTABELECIMENTO junto aos órgãos de proteção ao crédito.
			</p>


			<h7>
				<b>5. DA EFETIVA PRESTAÇÃO DOS SERVIÇOS EM CASOS DE CHARGEBACK OU CANCELAMENTO</b>
			</h7>

			<p style={{ textAlign: 'justify' }}>
				<b>5.1 </b>
				Em todos os casos de devolução, seja CHARGEBACK ou cancelamento, fica irrevogavelmente estabelecido que, com a aprovação da transação, o serviço foi efetivamente prestado pela LUCREE, sendo certo que serão devidas pelo ESTABELECIMENTO as taxas contratadas para o serviço, que também serão compensadas com os recebíveis nos mesmos moldes do quanto fora descrito na cláusula quarta acima.
			</p>


			<h7>
				<b>6. TERMOS DEFINIDOS</b>
			</h7>

			<p style={{ textAlign: 'justify' }}>
				<b>6.1 </b>
				Os termos que estiverem grafados neste instrumento com todas as letras maiúsculas terão os significados atribuídos a eles no Contrato de Credenciamento e Adesão de Estabelecimentos ao Sistema LUCREE.
			</p>

		</DivScrollBody>
	);
}
